module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [(_vm.identityList.length) ? _c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.identityList), function(identity, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identity.identity))]), _vm._v(" "), _c('td', [(identity.type == 1) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/matcher.png"
      }
    })]) : _vm._e(), _vm._v(" "), (identity.type == 2) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/fb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (identity.type == 3) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/google.png"
      }
    })]) : _vm._e(), _vm._v(" "), (identity.type == 4) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/line.png"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [(identity.is_active) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟動")]) : _vm._e(), _vm._v(" "), (!identity.is_active) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟動")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identity.edit_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(identity.create_time))])])
  }), 0)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("識別碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("登入類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟動狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("建立時間")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-017b51a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/Temp/MemberIdentityTableTemp.vue
// module id = 2296
// module chunks = 1